var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 2C98 2 126 30 126 64C126 98.25 98 126 64 126C29.75 126 2 98.25 2 64C2 30 29.75 2 64 2ZM64 118C93.75 118 118 93.75 118 64C118 34.25 93.5 10 64 10C34 10 10 34.5 10 64C10 94 34.25 118 64 118ZM99.25 49.5L54.25 94.25C53 95.25 51 95.25 50 94.25L28.5 72.5C27.25 71.25 27.25 69.5 28.5 68.25L30.5 66.25C31.75 65 33.75 65 34.75 66.25L52 83.5L93 43C94 41.75 96 41.75 97.25 43L99.25 45.25C100.5 46.25 100.5 48.25 99.25 49.5Z",
    fill: "#5CBE66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidicon);
export default __webpack_public_path__ + "static/media/validicon.c64c19dbb64d36091a922fc726d9f83b.svg";
export { ForwardRef as ReactComponent };